export const EXTRA_SMALL_SCREEN_SIZE_BREAKPOINT = 350;
export const SMALL_SCREEN_SIZE_BREAKPOINT = 550;
export const RESPONSIVE_VERSION_BREAKPOINT = 768;
export const CONNECTION_INFORMATION_MIN_WIDTH = 425;
export const LARGE_VERSION_BREAKPOINT = 1080;
export const EXTRA_LARGE_VERSION_BREAKPOINT = 1468;